module.exports = __webpack_public_path__ + "fa147abdeca787c7af08cae4de24fc0b.png";